<script lang="ts">
  import { router } from "@inertiajs/svelte";
  import { ModeWatcher } from "mode-watcher";
  import { Toaster } from "$lib/components/ui/sonner";
  import { toast } from "svelte-sonner";

  let { children }: { children?: import("svelte").Snippet } = $props();

  $effect(() => {
    return router.on("flash", (event) => {
      const flash = event.detail.flash as Record<string, string>;
      if (flash.alert) toast.error(flash.alert);
      if (flash.notice) toast.success(flash.notice);
    });
  });
</script>

<ModeWatcher />
<Toaster position="top-center" />
{@render children?.()}
